import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { makeStyles } from '@mui/styles';

export const TrashButton = ({ handleRemove }) => {
  const classes = useStyles();

  return (
    <button onClick={handleRemove} className={classes.btnClass}>
      <FontAwesomeIcon icon={faTrash} size="sm" />
    </button>
  );
};

const useStyles = makeStyles(() => ({
  btnClass: {
    border: '2px solid #000000',
    borderRadius: 3,
    height: 37,
    width: 37,
    margin: 10,
    userSelect: 'none',
    '&:focus': {
      outline: 'none',
      border: '2px solid #000000'
    },
    '&:active': {
      outline: 'none',
      border: '3px solid #000000'
    }
  }
}));
